<template>
  <a-layout class="container">
    <!-- 左侧区域 -->
    <hina-base-slider :currentMenuKey="curMenuKey" :currentOpenKey="curOpenKey" />
    <!-- 主体区域 -->
    <a-layout>
      <!-- 头部 -->
      <hina-user-info :user="objUserInfo" />

      <a-layout-content>
        <!-- 位置 -->
        <hina-bread-crumb :link="arrBreadLink" />

        <div class="wrapper">
          <div class="wrap">
            <div class="hd">
              <div class="filter">
                <div class="title">企业会员</div>
                <div class="query">
                  <div class="query-item">
                    <a-dropdown-button>
                      查询方式
                      <a-menu slot="overlay" @click="handleMenuClick" style="line-height: 48px">
                        <a-menu-item key="1">
                          <a-space v-if="strQueryType == '姓名'" style="color: #45a3ff">按姓名查询</a-space>
                          <a-space v-else>按姓名查询</a-space>
                        </a-menu-item>
                      </a-menu>
                      <a-icon slot="icon" type="user" />
                    </a-dropdown-button>
                  </div>
                  <div class="query-item">
                    <a-input v-model="queryParams" @keyup.enter="loadStaffList" type="text" />
                  </div>
                  <div class="query-item">
                    <a-button @click="loadStaffList" type="primary">查询</a-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="trans-table">
              <a-table
                :columns="columns"
                :row-key="record => record.userId"
                :data-source="data"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
              >
                <template slot="sourceSlot" slot-scope="text, record">
                    <span v-if="text == 1">健康神器</span>
                    <span v-if="text == 2">实体卡</span>
                    <span v-if="text == 3">企业邀请</span>
                    <span v-if="text == 4">渠道码</span>
                </template>
                <template slot="wxOpenStatusSlot" slot-scope="text, record">
                  <a-tag color="green" v-if="text">已激活</a-tag>
                  <a-tooltip v-if="!text">
                    <template slot="title">
                      企业成员重新在小程序登录后激活
                    </template>
                    <a-tag color="red">未激活</a-tag>
                  </a-tooltip>
                </template>
                <template slot="action" slot-scope="text, record">
                  <a href="javascript:;" @click="handlerInviteDetailsModel(record)">邀请明细</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="handlerInviteOrderDetailsModel(record)">消费记录</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="handlerCashbackPercentage(record)">返现金额</a>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </a-layout-content>

      <!-- 消费记录弹框 -->
      <a-modal
        v-model="inviteDetailsOrderModal"
        title="消费记录"
        :width="1300"
        :centered="true"
        :okButtonProps="{ style: { display: 'none' } }"
        cancelText="取消"
      >
        <!-- <div class="query" style="display: flex; align-items: center; margin-bottom: 20px">
          <div class="query-item">
            <a-dropdown-button>
              查询方式
              <a-menu
                slot="overlay"
                @click="handleMenuClick"
                style="line-height: 48px"
              >
                <a-menu-item key="2">
                  <a-space
                    v-if="strQueryType == '昵称'"
                    style="color: #45a3ff"
                    >按昵称查询</a-space
                  >
                  <a-space v-else>按昵称查询</a-space>
                </a-menu-item>
                <a-menu-item key="2">
                  <a-space
                    v-if="strQueryType == '手机号'"
                    style="color: #45a3ff"
                    >按手机查询</a-space
                  >
                  <a-space v-else>按手机查询</a-space>
                </a-menu-item>
              </a-menu>
              <a-icon slot="icon" type="user" />
            </a-dropdown-button>
          </div>
          <div class="query-item" style="margin: 0 10px;">
            <a-input
              v-model="pagination.keywords"
              @keyup.enter="getInviteOrderList"
              type="text"
            />
          </div>
          <div class="query-item">
            <a-button @click="getInviteOrderList" type="primary"
              >查询</a-button
            >
          </div>
        </div> -->
        <!-- <a-range-picker
            style="margin-bottom: 24px;"
            :show-time="{ format: 'HH:mm' }"
            format="YYYY-MM-DD HH:mm"
            :placeholder="['开始时间', '结束时间']"
            :locale="locale"
            @change="onDateTimeChange"
            @ok="onDateTimeOk"
          >
            <a-icon slot="suffixIcon" type="calendar" />
          </a-range-picker> -->
        <a-table
          bordered
          :columns="inviteOrderColumns"
          :data-source="inviteOrderData"
          :row-key="record => record.id"
          :pagination="paginationOrderInvite"
          @change="handleInviteOrderTableChange"
        >
          <template slot="state" slot-scope="text, record">
            <span>{{ stateMap[text] }}</span>
          </template>
        </a-table>
      </a-modal>
      <!-- 邀请明细弹框 -->
      <a-modal
        v-model="inviteDetailsModal"
        title="邀请明细"
        :width="760"
        :centered="true"
        :okButtonProps="{ style: { display: 'none' } }"
        cancelText="取消"
      >
        <a-table
          bordered
          :columns="inviteColumns"
          :data-source="inviteData"
          :row-key="record => record.id"
          :pagination="paginationInvite"
          @change="handleInviteTableChange"
        >
        </a-table>
      </a-modal>
      <!-- 返现金额 -->
      <a-modal
        v-model="cashbackPercentageState"
        title="返现金额"
        :width="760"
        :centered="true"
        okText="确认"
        cancelText="取消"
        @ok="handleOkEve"
      >
        <a-form-model :model="cashbackPercentageParams" :label-col="{span: 4}" :wrapper-col="{span: 10}">
            <a-form-model-item label="设置返现金额">
                <a-input v-model="cashbackPercentageParams.cashbackAmount" :min="1" :max="439" @change="percentageChangeEve" type="Number" style="width: 300px;"/>
            </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-layout>
  </a-layout>
</template>

<script>
import HinaBaseSlider from 'components/HinaBaseSlider/HinaBaseSlider'
import HinaUserInfo from 'components/HinaUserInfo/HinaUserInfo'
import HinaBreadCrumb from 'components/HinaBreadCrumb/HinaBreadCrumb'
import utils from 'assets/js/util'
import vueQr from 'vue-qr'
import locale from 'ant-design-vue/lib/date-picker/locale/zh_CN'

const columns = [
  {
    title: '用户昵称',
    dataIndex: 'name'
  },
  {
    title: '用户手机号',
    dataIndex: 'phone'
  },
  {
      title: '来源',
      dataIndex: 'source',
      scopedSlots: { customRender: 'sourceSlot' }
  },
  {
      title: '订单价格(元)',
      dataIndex: 'practicalPrice'
  },
  {
    title: '收益',
    dataIndex: 'money'
  },
  {
    title: '返现金额',
    dataIndex: 'cashbackAmount'
  },
  {
    title: '客户池人数',
    dataIndex: 'inviterCount'
  },
  {
    title: '成员状态',
    dataIndex: 'wxOpenStatus',
    scopedSlots: { customRender: 'wxOpenStatusSlot' }
  },
  {
    title: '邀请人',
    dataIndex: 'inviterName'
  },
  {
    title: '被邀请时间',
    dataIndex: 'inviterTime'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'Profile',
  components: {
    HinaBaseSlider,
    HinaUserInfo,
    HinaBreadCrumb,
    vueQr
  },
  data() {
    return {
      locale,
      frmAllocation: {},
      objUserInfo: {},
      curMenuKey: ['inviteStatistics'],
      curOpenKey: ['sub4'],
      arrBreadLink: [],
      color: 'error',
      loading: false,
      strQueryType: '姓名',
      queryParams: '',
      data: [],
      columns,

      inviteDetailsOrderModal: false, //消费记录弹框
      stateMap: {
        UNPAID: '未付款',
        PAID: '已付款',
        SERVE: '服务中',
        SEND_COMPLETED: '下单人已完成',
        RECEIVING_COMPLETED: '接单人已完成',
        COMPLETED: '订单已完成',
        RECEIVING: '已接单',
        CANCEL: '已取消',
        REFUNDED: '已退款',
        OVER_TIME_PAY: '订单超时',
        FINISH: '订单已分账'
      },
      inviteOrderColumns: [
        {
          title: '订单号',
          dataIndex: 'sn'
        },
        {
          title: '所属地区',
          dataIndex: 'adCodeName'
        },
        {
          title: '订单类型',
          dataIndex: 'type',
          customRender: (text, record) => {
            const typeMap = {
              ACCOMPANY_DIAGNOSE: {
                WHOLE_COURSE: '全程陪诊',
                COURT: '院内陪诊',
                DIFFERENT: '异地陪诊',
                TEMPERATURE_TAKING: '体检陪同'
              },
              SMART_GUIDE: {
                SMART_SUGGEST: '智能建议',
                SMART_TELEPHONE_COUNSELING: '智能建议电话咨询',
                IMAGE_TEXT_COUNSELING: '图文咨询',
                TELEPHONE_COUNSELING: '电话咨询'
              },
              GUIDE_DIAGNOSE: '导诊',
              BUY_MEDICINE: '买药',
              INTERROGATION_DIAGNOSE: '问诊',
              SEND_RESULTS: '送取结果',
              OPEN_VIP: '开通会员',
              RENEW: '加时包',
              BUY_VIDEO: '视频',
              BUY_VIDEO_PACKAGE: '视频包',
              EXAMINE: '高端体检',
              OPEN_VIP_YEAR: '年会员'
            }

            const type = record.type
            const accompanyType = record.accompanyType
            const smartGuideType = record.smartGuideType

            if (type === 'ACCOMPANY_DIAGNOSE' && typeMap[type][accompanyType]) {
              return `${typeMap[type][accompanyType]}`
            } else if (type === 'SMART_GUIDE' && typeMap[type][smartGuideType]) {
              return `${typeMap[type][smartGuideType]}`
            } else {
              return `${typeMap[type]}`
            }
          }
        },
        {
          title: '订单状态',
          dataIndex: 'state',
          key: 'state',
          scopedSlots: { customRender: 'state' }
        },

        {
          title: '下单时间',
          dataIndex: 'createTime'
        },
        {
          title: '支付时间',
          dataIndex: 'payTime'
        },
        {
          title: '下单人',
          dataIndex: 'sendUserName'
        },

        {
          title: '订单价格',
          dataIndex: 'price'
        },
        {
          title: '订单完成时间',
          dataIndex: 'finishTime'
        }
      ],
      inviteData: [],
      inviteOrderData: [],
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1
      },
      paginationOrderInvite: {
        pageSize: 5,
        total: 0,
        current: 1,
        // startDate:'',
        // endDate:'',
        keywords: ''
      },
      paginationInvite: {
        pageSize: 5,
        total: 0,
        current: 1
      },
      inviteDetailsModal: false, //邀请明细弹框
      inviteColumns: [
        {
          title: '用户昵称',
          dataIndex: 'name'
        },
        {
          title: '手机号',
          dataIndex: 'phone'
        },
        {
          title: '收益',
          dataIndex: 'money'
        },
        {
          title: '邀请时间',
          dataIndex: 'inviterTime'
        }
      ],
      cashbackPercentageState: false, // 返现金额弹窗状态
      cashbackPercentageParams: {
        userId: '', // 用户ID
        cashbackAmount: 0, // 比例数值，Number
      }, // 设置返现金额参数
    }
  },

  methods: {
    // 返现金额弹窗确认事件
    handleOkEve() {
        if (!this.cashbackPercentageParams.cashbackAmount) {
            this.$message.error('请设置返现金额！')
            return
        }
        this.$get(`/enterpriseUser/settringUserPercentage`, this.cashbackPercentageParams).then(res => {
            if (res.success) {
                this.$message.success('返现金额设置成功！');
                this.cashbackPercentageState = false
                this.loadStaffList()
            }
        })
    },
    // 返现金额值变化
    percentageChangeEve(e) {
        if (Number(this.cashbackPercentageParams.cashbackAmount) > 439) {
            this.cashbackPercentageParams.cashbackAmount = 439
        }
        if (Number(this.cashbackPercentageParams.cashbackAmount) < 0) {
            this.cashbackPercentageParams.cashbackAmount = 0
        }
    },
    // 返现金额弹窗
    handlerCashbackPercentage(record) {
      this.cashbackPercentageState = true
      this.cashbackPercentageParams.userId = record.userId
      this.cashbackPercentageParams.cashbackAmount = record.cashbackAmount
    },
    //查询列表
    loadStaffList() {
      //查询对象
      let params = {
        name: null,
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      params.name = this.queryParams
      this.data = []
      this.$get('/enterpriseUser/getInviteUserInfo', params).then(res => {
        let records = res.result.records
        this.data = records
        this.pagination = {
          current: res.result.current,
          pageSize: res.result.size,
          total: res.result.total
        }
        this.loading = false
      })
    },
    //查询邀请记录列表
    loadInviteList() {
      //查询对象
      let params = {
        pageNumber: this.paginationInvite.current,
        pageSize: this.paginationInvite.pageSize
      }
      this.inviteData = []
      // this.$get('/enterpriseUser/getSubInviteUser/'+this.userId, params).then((res) => {
      this.$get('/enterpriseUser/getUserInfoByInviteId?id=' + this.userId, params).then(res => {
        let records = res.result.records
        this.inviteData = records
        this.paginationInvite = {
          current: res.result.current,
          pageSize: res.result.size,
          total: res.result.total
        }
        this.loading = false
      })
    },

    handleMenuClick: function(e) {
      if (e.key == 1) {
        this.strQueryType = '姓名'
      }
      if (e.key == 2) {
        this.strQueryType = '昵称'
      } else {
        this.strQueryType = '手机号'
      }
    },

    handlerAllocationModal: function(record) {
      this.isAllocationStaff = !this.isAllocationStaff
      this.frmAllocation.userId = record.userId
      this.frmAllocation.id = record.id
      console.log(this.frmAllocation)
    },
    // 消费记录弹框
    handlerInviteOrderDetailsModel(record) {
      this.inviteDetailsOrderModal = true
      this.userId = record.userId
      this.getInviteOrderList()
    },
    // 邀请记录弹框
    handlerInviteDetailsModel(record) {
      this.inviteDetailsModal = true
      this.userId = record.userId
      this.loadInviteList()
    },
    handleInviteOrderTableChange(pagination, filters, sorter, currentDataSource) {
      this.paginationOrderInvite.current = pagination.current
      this.getInviteOrderList()
    },
    handleInviteTableChange(pagination, filters, sorter, currentDataSource) {
      this.paginationInvite.current = pagination.current
      this.loadInviteList()
    },
    onDateTimeChange: function(value, dateString) {
      console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
      this.paginationOrderInvite.startDate = dateString[0]
      this.paginationOrderInvite.endDate = dateString[1]
    },
    onDateTimeOk: function(value) {
      console.log('onDateTimeOk: ', value)
      this.getInviteOrderList()
    },
    // 消费记录列表
    getInviteOrderList() {
      let params = {
        pageNumber: this.paginationOrderInvite.current,
        pageSize: this.paginationOrderInvite.pageSize,
        startDate: this.paginationOrderInvite.startDate,
        endDate: this.paginationOrderInvite.endDate,
        keywords: this.paginationOrderInvite.keywords,
        sendUserId: this.userId
      }
      this.$get(`/order/page`, params).then(res => {
        this.inviteOrderData = res.result.records
        this.paginationOrderInvite = {
          current: res.result.current,
          pageSize: res.result.size,
          total: res.result.total
        }
      })
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loading = true
      this.loadStaffList()
    }
  },
  mounted: function() {
    this.objUserInfo = {
      id: this.$store.state.userInfo.id,
      name: this.$store.state.userInfo.enterpriseFullName
    }
    this.arrBreadLink.push({ name: '企业会员', link: '/inviteStatistics' })
    this.loadStaffList()
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .wrap {
    margin: 20px 0 0;
    padding: 0 24px;
    background: #fff;
    min-height: 240px;

    .hd {
      height: 72px;
      line-height: 72px;
      color: #333;
      font-weight: 600;
      font-size: 18px;
      position: relative;
      margin-bottom: 30px;

      &::after {
        position: absolute;
        content: '';
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 0;
        right: 0;
        bottom: 0;
      }

      .filter {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .query {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .query-item {
            padding: 0 0 0 5px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .trans-table {
      padding: 0 0 5px;
    }
  }

  .wrap:first-of-type {
    margin: 0;
  }
}

.frm-staff {
  padding: 20px 50px;
  text-align: center;

  .frm-line {
    min-height: 72px;
    padding: 12px 0;
    box-sizing: border-box;

    .lab {
      font-size: 16px;
      line-height: 48px;
      text-align: right;
      position: relative;

      &::after {
        position: relative;
        content: '：';
      }
    }

    .required {
      &::before {
        position: relative;
        content: '*';
        color: red;
        padding: 0 5px 0 0;
      }
    }

    .txt {
      line-height: 48px;
      font-size: 16px;
    }
  }
}
</style>
